export default {
  contentBox: {
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  buttonBox: {
    width: '100%',
    height: '100%',
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  videoBackdrop: {
    zIndex: 2000,
  },
  closeButton: {
    width: 200,
    margin: 25,
    zIndex: 3000,
  },
}
